import React, { useState, useEffect, useMemo } from 'react';
import classnames from 'classnames';
import { Layout, Button, Segment } from 'tea-component';
import { history, useIntl } from 'umi';
import BubbleClose from '@/pages/intelligence/components/BubbleClose';
import '@/pages/intelligence/assets/scss/Following/index.scss';
import { buriedPointPage, typeIdObj, buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { getFollwingPageLogMes } from '@/pages/intelligence/pages/Following/_config/util';
import CurrentGames from './CurrentGames';
import NewGames from './NewGames';
import useFollowingUnifiedIdModel from '@/pages/intelligence/hooks/useHasFollowed';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { useFollowingOptionList } from '@/pages/intelligence/pages/Following/_hook/useFollowingOptionList';
import { fetchGuideStatus } from '@/pages/intelligence/services/topcharts';
import GuideFollowing, {
  FOLLOWING_GUIDE_CLASSNAMES,
} from '@intelligence/components/UserGuide/Following';
import { IS_GLOBAL } from '@/pages/home/_config/config';
import MarqueeBanner from '@/pages/intelligence/components/MarqueeBanner/index';
import {
  currentGamesFilterCfg,
  newGamesFilterCfg,
  DEFAULT_GROUPNAME,
} from '@intelligence/pages/Following/_config/filterCfg';
import useFollowingGroupFilter from '@/pages/intelligence/pages/Following/_hook/useFollowingGroupFilter';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';

const { Body, Content } = Layout;

const getValidTab = (tab: string) => {
  const [gamePart, entityTypePart] = tab?.split('_');

  const { follwowingSegOptions, follwowingSegOptionsRight } = useFollowingOptionList({});

  const leftValues = follwowingSegOptions.map((item) => item.value);
  const rightValues = follwowingSegOptionsRight.map((item) => item.value);

  const isValidValue = (value: string, validValues: string[]) =>
    validValues.includes(value) ? value : undefined;

  //Global环境默认为PC标签
  const defautletTab = IS_GLOBAL ? leftValues?.[1] : leftValues?.[0];
  const leftTab = isValidValue(entityTypePart, leftValues) ?? defautletTab;
  const rightTab = isValidValue(gamePart, rightValues) ?? rightValues?.[0];

  return { leftTab, rightTab };
};

export default function Following(props: any) {
  const {} = props;
  const activeTab = props?.match?.params?.tab || '';
  const [showManageBtnBubble, setShowManageBtnBubble] = useState(false);
  const [isUpdateBasicInfo, setIsUpdateBasicInfo] = useState(true);

  const { formatMessage } = useIntl();

  const { follwowingSegOptions, follwowingSegOptionsRight } = useFollowingOptionList({});

  const { loading: uidsLoading, unifiedIds } = useFollowingUnifiedIdModel({
    isgetData: isUpdateBasicInfo,
    setIsUpdateBasicInfo,
  });
  const [leftSegment, setLeftSegment] = useState(getValidTab(activeTab).leftTab);
  const [rightSegment, setRightSegment] = useState(getValidTab(activeTab).rightTab);
  const [activeSegment, setActiveSegment] = useState(`${rightSegment}_${leftSegment}`);

  const { groupOptions, setUpdateGroupList } = useFollowingGroupFilter({
    entityType: leftSegment,
    DEFAULT_GROUPNAME,
  });

  const { filterLoading, regionOptions } = useMarketFilterApi({});
  const filterCfgFun = rightSegment === 'newgames' ? newGamesFilterCfg : currentGamesFilterCfg;
  const filterCfg = filterCfgFun?.({
    entityType: leftSegment,
    regionOptions,
    groupOptionsData: groupOptions,
  });

  const getFetchGuideStatus = async (params: any) => {
    try {
      const res = await fetchGuideStatus(params);
      if (res?.code === 0) {
        setShowManageBtnBubble(res?.data);
      }
    } catch (e) {}
  };

  const getFirstGuideStatus = () => {
    getFetchGuideStatus({
      // Topchart榜单第一个落地页表格关注提示
      button_id: dbiBtnLogMes.followingGamesManageButton.buttonId,
      type_id: typeIdObj.intelligence,
    });
  };

  useEffect(() => {
    getFirstGuideStatus();
    handlePageLog(leftSegment, rightSegment);
  }, []);

  const handlePageLog = (entityType: string, tab: string) => {
    const pageLogMes = getFollwingPageLogMes(entityType, tab);
    if (pageLogMes) {
      buriedPointPage(pageLogMes);
    }
  };

  const onBubbleClose = () => {
    // 表格关注提示关闭打点
    buriedBtnPoint(dbiBtnLogMes.followingGamesManageButton);
    setShowManageBtnBubble(false);
  };

  const changeUrl = (activeSubTab: string) => {
    history.replace(`/intelligence/following/${activeSubTab}`);
  };

  function renderGames(mainSegment: string, subSegment: string) {
    if (mainSegment === 'currentgames' || mainSegment === 'newgames') {
      const validSubSegments = ['mobile', 'pc', 'console', 'company'];
      const RenderCmp = mainSegment === 'currentgames' ? CurrentGames : NewGames;

      if (validSubSegments.includes(subSegment)) {
        return (
          // React会识别到key值的变化，并重新销毁和渲染组件
          <div key={`${mainSegment}-${subSegment}`}>
            <RenderCmp
              loading={uidsLoading}
              setIsUpdateBasicInfo={setIsUpdateBasicInfo}
              entityType={leftSegment}
              hasFollowIds={unifiedIds?.[activeSegment]}
              pageLogMes={getFollwingPageLogMes(leftSegment, rightSegment)}
              DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
              groupOptions={groupOptions}
              setUpdateGroupList={setUpdateGroupList}
              filterLoading={filterLoading}
              filterCfg={filterCfg}
            />
          </div>
        );
      }
    }
    return null;
  }

  return (
    <Content className="dbi-following-page affix-target">
      <Content.Header
        title={formatMessage({ id: 'dbi_menu_following' })}
        operation={
          // hasFollowData && unifiedIds?.[activeSegment] !== null ? (
          // 需要开发判断 弹框第一次出现
          <BubbleClose
            style={{ width: '400px' }}
            content={formatMessage({
              id: 'dbi_info_following_manage_btn',
            })}
            visible={showManageBtnBubble}
            onClose={onBubbleClose}
          >
            <Button
              type="primary"
              onClick={() => history.push(`/intelligence/following/manage/${leftSegment}`)}
            >
              {formatMessage({ id: 'dbi_manage' })}
            </Button>
          </BubbleClose>
          // ) : null
        }
      />
      <Content.Body full>
        <MarqueeBanner />
        <div className="dbi-following-page-flex">
          <Segment
            className="segment-light following-segment"
            value={leftSegment}
            options={
              rightSegment === 'newgames'
                ? follwowingSegOptions.filter((option) => !option.noNewGame)
                : follwowingSegOptions
            }
            onChange={(value) => {
              setLeftSegment(value);
              const activeSegmentForUrl = `${rightSegment}_${value}`;
              setActiveSegment(activeSegmentForUrl);
              handlePageLog(value, rightSegment);
              changeUrl(activeSegmentForUrl);
            }}
          />
          {leftSegment !== 'company' && (
            <Segment
              className={classnames('segment-light', FOLLOWING_GUIDE_CLASSNAMES.ELEMENT2)}
              value={rightSegment}
              options={follwowingSegOptionsRight}
              onChange={(value) => {
                setRightSegment(value);
                const activeSegmentForUrl = `${value}_${leftSegment}`;
                setActiveSegment(activeSegmentForUrl);
                handlePageLog(leftSegment, value);
                changeUrl(activeSegmentForUrl);
              }}
            />
          )}
        </div>
        {renderGames(rightSegment, leftSegment)}
        <GuideFollowing />
      </Content.Body>
    </Content>
  );
}
